<template>
  <div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) of bannerInfo" :key="index">
        <img :src="item.img" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';

export default {
  props: ['bannerInfo'],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
}
</script>
<style lang="scss" scoped>
.my-swipe .van-swipe-item {
  height: 3.84rem;
}
.van-swipe-item img {
  // object-fit: cover;
}
img {
  width: 100%;
  height: 3.84rem;
}
</style>